import { z } from 'zod';
export var EventType;
(function (EventType) {
    EventType["BoardMeeting"] = "Board Meeting";
    EventType["CommitteeMeeting"] = "Committee Meeting";
    EventType["Congress"] = "Congress";
    EventType["Webinar"] = "Webinar";
    EventType["Workshop"] = "Workshop";
})(EventType || (EventType = {}));
export var KolProfileDataType;
(function (KolProfileDataType) {
    KolProfileDataType["Associations"] = "associations";
    KolProfileDataType["Affiliations"] = "affiliations";
    KolProfileDataType["ClinicalTrials"] = "clinical-trials";
    KolProfileDataType["Collaborations"] = "collaborations";
    KolProfileDataType["Conferences"] = "conferences";
    KolProfileDataType["ContactInfo"] = "contact-info";
    KolProfileDataType["HCPInteractions"] = "hcp-interactions";
    KolProfileDataType["LeaderTopics"] = "leader-topics";
    KolProfileDataType["MunData"] = "mun-data";
    KolProfileDataType["Publications"] = "publications";
    KolProfileDataType["Sponsorships"] = "sponsorships";
    KolProfileDataType["StrategicImperatives"] = "strategic-imperatives";
})(KolProfileDataType || (KolProfileDataType = {}));
export const KolProfileDataTypeModel = z.nativeEnum(KolProfileDataType);
export const KolProfileDataTypeLabels = {
    [KolProfileDataType.Associations]: 'Associations',
    [KolProfileDataType.Affiliations]: 'Affiliations',
    [KolProfileDataType.ContactInfo]: 'Contact Info',
    [KolProfileDataType.ClinicalTrials]: 'Clinical Trials',
    [KolProfileDataType.Collaborations]: 'Collaborations',
    [KolProfileDataType.Conferences]: 'Conferences',
    [KolProfileDataType.HCPInteractions]: 'HCP Interactions',
    [KolProfileDataType.LeaderTopics]: 'Leader Topics',
    [KolProfileDataType.MunData]: 'MUN Data',
    [KolProfileDataType.Publications]: 'Publications',
    [KolProfileDataType.Sponsorships]: 'Sponsorships',
    [KolProfileDataType.StrategicImperatives]: 'Strategic Imperatives',
};
export var KolDataSource;
(function (KolDataSource) {
    KolDataSource["CRM"] = "crm";
    KolDataSource["HcpContactInfo"] = "hcp-contact-info";
    KolDataSource["IConnect"] = "iConnect";
    KolDataSource["MeAi"] = "me-ai";
    KolDataSource["VeevaLink"] = "veeva-link";
    KolDataSource["NA"] = "na";
    KolDataSource["Unknown"] = "unknown";
})(KolDataSource || (KolDataSource = {}));
export const KolDataSourceLabels = {
    [KolDataSource.HcpContactInfo]: 'HCP Contact Info',
    [KolDataSource.IConnect]: 'iConnect',
    [KolDataSource.MeAi]: 'ME.AI',
    [KolDataSource.VeevaLink]: 'Veeva Link',
    [KolDataSource.NA]: 'N/A',
    [KolDataSource.CRM]: 'CRM',
    [KolDataSource.Unknown]: 'Unknown',
};
export const KolProfileDataTypeSourcesMap = {
    [KolProfileDataType.Associations]: KolDataSource.VeevaLink,
    [KolProfileDataType.Affiliations]: KolDataSource.VeevaLink,
    [KolProfileDataType.ClinicalTrials]: KolDataSource.VeevaLink,
    [KolProfileDataType.Collaborations]: KolDataSource.VeevaLink,
    [KolProfileDataType.ContactInfo]: KolDataSource.HcpContactInfo,
    [KolProfileDataType.Conferences]: KolDataSource.VeevaLink,
    [KolProfileDataType.HCPInteractions]: KolDataSource.IConnect,
    [KolProfileDataType.LeaderTopics]: KolDataSource.VeevaLink,
    [KolProfileDataType.MunData]: KolDataSource.MeAi,
    [KolProfileDataType.Publications]: KolDataSource.VeevaLink,
    [KolProfileDataType.Sponsorships]: KolDataSource.VeevaLink,
    [KolProfileDataType.StrategicImperatives]: KolDataSource.NA,
};
export var KolSearchStatusEnum;
(function (KolSearchStatusEnum) {
    KolSearchStatusEnum["FormEntry"] = "form-entry";
    KolSearchStatusEnum["FormSubmitted"] = "form-submitted";
    KolSearchStatusEnum["FormSubmissionErrored"] = "form-submission-errored";
    KolSearchStatusEnum["NoResultsReturned"] = "no-results-returned";
    KolSearchStatusEnum["SingleResultReturned"] = "single-result-returned";
    KolSearchStatusEnum["MultipleResultsReturned"] = "results-returned";
    KolSearchStatusEnum["SearchCancelled"] = "search-cancelled";
    KolSearchStatusEnum["ProfileSelectionSubmitted"] = "profile-selection-submitted";
    KolSearchStatusEnum["ProfileSelected"] = "profile-selected";
    KolSearchStatusEnum["ProfileSelectionErrored"] = "profile-selection-errored";
    KolSearchStatusEnum["ProfileRecommendations"] = "profile-recommendations";
    KolSearchStatusEnum["QuestionsBank"] = "questions-bank";
})(KolSearchStatusEnum || (KolSearchStatusEnum = {}));
export const KolProfileDataTypeTables = {
    [KolProfileDataType.Associations]: ['Associations'],
    [KolProfileDataType.Affiliations]: ['Addresses'],
    [KolProfileDataType.ContactInfo]: ['PhysicianProfiles', 'ScientificExperts'],
    [KolProfileDataType.ClinicalTrials]: ['ClinicalTrials', 'ClinicalTrialRelations'],
    [KolProfileDataType.Collaborations]: ['CompanyCollaborations'],
    [KolProfileDataType.Conferences]: ['MedicalEvents', 'EventAttendees'],
    // [KolProfileDataType.Events]: ['MedicalEvents', 'EventAttendees'],
    [KolProfileDataType.HCPInteractions]: [
        'DocumentedInterestAccounts',
        'MedicalInsights',
        'MICCInteractions',
        'PhysicianMSLInteractions',
    ],
    [KolProfileDataType.LeaderTopics]: [
        'DigitalReachFocusAreas',
        'FocusAreas',
        'ClinicalLeaders',
    ],
    [KolProfileDataType.MunData]: ['AggregatedMunData', 'MunCallPlanTargets'],
    [KolProfileDataType.Publications]: ['Publications', 'PublicationRelations'],
    [KolProfileDataType.Sponsorships]: ['CompanySponsorships'],
    [KolProfileDataType.StrategicImperatives]: [],
};
